
import { createRoot } from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import App from './App.tsx'
import './index.css'

// ==========================================
// DEPLOYMENT VERSION: 2025-10-09-V5-DEALS-FIX
// BUILD TIMESTAMP: 2025-10-09T21:45:00Z  
// MAJOR UPDATE: DEALS PAGE FULLY FUNCTIONAL
// ==========================================
const BUILD_VERSION = 'v5.0-DEALS';
const BUILD_DATE = '2025-10-09T21:45Z';
const BUILD_ID = Math.random().toString(36).substring(2, 11);

console.log('');
console.log('██████████████████████████████████████████');
console.log('🚀 CONTRACT CASH NEXUS - VERSION 5.0');
console.log('📅 Build: 2025-10-09 @ 9:45 PM');
console.log('⏰ Loaded:', new Date().toISOString());
console.log('🔢 Build ID:', BUILD_ID);
console.log('🌐 URL:', window.location.href);
console.log('✅ DEALS PAGE INCLUDED - LATEST VERSION');
console.log('██████████████████████████████████████████');
console.log('');

// Store version info globally
(window as any).__APP_VERSION__ = {
  version: BUILD_VERSION,
  buildDate: BUILD_DATE,
  buildId: BUILD_ID,
  hasDeals: true
};

// LARGE VISIBLE VERSION BADGE
const versionBadge = document.createElement('div');
versionBadge.id = 'version-indicator';
versionBadge.innerHTML = `
  <div style="font-weight:bold;font-size:13px;margin-bottom:4px;">🎯 VERSION 5.0 LOADED</div>
  <div style="font-size:10px;opacity:0.9;">Build: ${BUILD_DATE}</div>
  <div style="font-size:10px;opacity:0.9;">ID: ${BUILD_ID}</div>
  <div style="font-size:10px;color:#0f0;margin-top:4px;">✅ DEALS ACTIVE</div>
`;
versionBadge.style.cssText = `
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(0, 0, 0, 0.95);
  color: #0f0;
  padding: 20px 30px;
  border-radius: 8px;
  font-family: monospace;
  text-align: center;
  z-index: 999999;
  border: 2px solid #0f0;
  box-shadow: 0 0 20px rgba(0, 255, 0, 0.5);
`;

// Add to page immediately
if (document.body) {
  document.body.appendChild(versionBadge);
} else {
  document.addEventListener('DOMContentLoaded', () => {
    document.body.appendChild(versionBadge);
  });
}

// Fade out after 8 seconds
setTimeout(() => {
  versionBadge.style.transition = 'opacity 1s';
  versionBadge.style.opacity = '0';
  setTimeout(() => versionBadge.remove(), 1000);
}, 8000);

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);
